export const filter = {
  period: 'Period',
  period_buy: 'Purchase period',
  search: 'Search',
  show_result: 'Show',
  name: 'Name',
  mcc: 'MCC',
  mnc: 'MNC'
};
